<template>
  <b-col cols="12" md="6" :lg="getFiltersVisibility ? '6' : '4'" class="mb-4">
    <b-card
      no-body
      bg-variant="white"
      class="mb-4 h-100 border-2 border-dotted child-card-list"
      border-variant="child-card-list"
      footer-class="p-0 m-0 border-0"
      footer-bg-variant="white"
    >
      <b-card-body class="m-0 p-0 d-flex flex-column justify-content-between">
        <ChildHeader
          :firstName="item.first_name"
          :province="item.province"
          :birthyear="item.birthyear"
          :daysWaiting="item.days_waiting"
          :childData="item"
          :loader="loader"
        ></ChildHeader>
        <ChildDescription
          :loader="loader"
          :futureSelf="guardianConsent.futureSelf"
          :threeWordsDescription="guardianConsent.threeWordsDescription"
        >
        </ChildDescription>
        <b-skeleton
          v-if="loader"
          variant="mint"
          class="mx-4"
          height="125px"
          animation="fade"
        ></b-skeleton>
        <router-link
          v-else
          :to="childPageRoute()"
          v-slot="{ href, navigate }"
          custom
          class="router-link"
        >
          <a @click="navigate" :href="href" class="router-link">
            <MoneyProgressBar
              :fundraising="fundraising"
              :firstNameGenitive="item.first_name_genitive"
            ></MoneyProgressBar
          ></a>
        </router-link>
      </b-card-body>
      <template #footer>
        <b-row class="py-3" align-h="center">
          <b-col cols="auto">
            <router-link :to="childPageRoute()" v-slot="{ href, navigate }" custom>
              <b-skeleton
                v-if="loader"
                type="button"
                animation="fade"
                variant="primary"
                width="168px"
                height="42px"
              >
              </b-skeleton>
              <b-button
                v-else
                @click="navigate"
                :href="href"
                class="px-4 rounded-xl text-md font-weight-bold line-height-lg"
                variant="primary"
              >
                {{ childCardButtonText }}
                <i class="angle-right-icon ml-1 bg-white"></i>
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </b-col>
</template>

<script>
import MoneyProgressBar from '@/components/widgets/childCard/MoneyProgressBar.vue'
import ChildHeader from '@/components/widgets/childCard/ChildHeader.vue'
import ChildDescription from '@/components/widgets/childCard/ChildDescription.vue'

export default {
  name: 'ChildCard',
  components: {
    ChildDescription,
    ChildHeader,
    MoneyProgressBar
  },
  props: {
    item: {
      required: true
    },
    loader: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    childCardButtonText() {
      const firstNameAccusative = this.item && this.item.first_name_accusative
      if (firstNameAccusative) {
        return `${this.$t('childrenList.card.meet')} ${firstNameAccusative}`
      }
      return this.$t('childrenList.card.meetChild')
    },
    getFiltersVisibility() {
      return this.$store.getters['filter/getFiltersVisibility']
    },
    guardianConsent() {
      return (this.item && this.item.guardian_consent_content_child_choice_path) || {}
    },
    fundraising() {
      if (this.item?.open_fundraising) {
        return {
          paid_amount: this.item.paid_amount ?? 0
        }
      }
      return null
    }
  },
  methods: {
    childPageRoute() {
      return { name: 'ChildPage', params: { childEditionId: this.item.id } }
    }
  }
}
</script>
